module.exports = __webpack_public_path__ + "img/card4.247b243e.png";